import React from 'react';
import { Form } from 'reactstrap';

function CustomForm({ ...rest }) {
  return <Form {...rest} />;
}

export default CustomForm;
